ci_states.state('devices_by_postal_code', {
    url: '/devices_by_postal_code',
    controller: 'DevicesByPostalCodeController',
    template: '<react scope="scope" feature="feature"></react>',
    ncyBreadcrumb: {
        label: 'Devices By Postal Code'
    }
}).state('custom_reports', {
    url: '/custom_reports',
    templateUrl: 'partials/custom_report/custom_report_list.html',
    controller: 'CustomReportListController',
    ncyBreadcrumb: {
        label: 'Custom Reports'
    }
}).state('custom_reports_view', {
    url: '/custom_reports/:id',
    templateUrl: 'partials/custom_report/custom_report_view.html',
    controller: 'CustomReportViewController',
    ncyBreadcrumb: {
        parent: 'custom_reports',
        label: 'Custom Report #{{ report.id }}'
    }
}).state('ad_links', {
    url: '/ad_links',
    templateUrl: 'partials/ad/ad_list_links.html',
    controller: 'AdLinksListController',
    ncyBreadcrumb: {
        label: 'Ad Links'
    }
}).state('queues', {
    url: '/queues',
    templateUrl: 'partials/queue/queue_list.html',
    controller: 'QueueListController',
    ncyBreadcrumb: {
        label: 'Queues'
    }
}).state('postal_code_reports', {
    url: '/postal_code_reports',
    templateUrl: 'partials/postal_code/postal_code_report_list.html',
    controller: 'PostalCodeReportsListController',
    ncyBreadcrumb: {
        label: 'Postal Code Reports'
    }
}).state('fraud_prevention_usage', {
    url: '/fraud_prevention_usage',
    templateUrl: 'partials/fraud_prevention_usage/fraud_prevention_usage_list.html',
    controller: 'FraudPreventionUsageListController',
    ncyBreadcrumb: {
        label: 'Fraud Prevention Usage'
    }
}).state('postal_code_reports_view', {
    url: '/postal_code_reports/:id',
    templateUrl: 'partials/postal_code/postal_code_report_view.html',
    controller: 'PostalCodeReportViewController',
    ncyBreadcrumb: {
        parent: 'postal_code_reports',
        label: '{{ postal_code_report.name }}'
    }
}).state('ads', {
    url: '/ads',
    controller: 'AdListController',
    templateUrl: 'partials/ad/ad_list.html',
    ncyBreadcrumb: {
        label: 'Creatives'
    }
}).state('management', {
    url: '/management?start_date&end_date',
    templateUrl: 'partials/management/management_analytics.html',
    controller: 'ManagementAnalyticsController',
    reloadOnSearch: true,
    ncyBreadcrumb: {
        label: 'Management'
    }
});